module.exports = __webpack_public_path__ + "media/customizations/smartlife/back-403ca46d5969c6b4f51ac518e2224467.jpg";